import { ref } from 'vue'

import { request } from '@/lib/services'

export const useGetEmailQuota = () => {
  const quota = ref<number>(0)
  const isLoading = ref<boolean>(false)

  const getEmailsQuota = async (advertiserId: number) => {
    isLoading.value = true
    try {
      const { data } = await request.get(`/v2/advertisers/${advertiserId}/email-quota`)
      quota.value = data.email_quota.remaining
    } catch {
      quota.value = 0
    }
    isLoading.value = false
  }

  return {
    quota,
    isLoading,
    getEmailsQuota,
  }
}
